import { useState } from "react";

const title = "Our Values";
const subtitle = "The principles that drive our mindset, shape our culture, and fuel every victory.";

let OurValuesData = [
  {
    id: 1,
    image: 'assets/images/gallery/value1.jpg',
    title: 'All In',
    desc: 'We bring full intensity to everything we do and always deliver at our highest level.',
    catagory: 'playstation',
  },
  {
    id: 2,
    image: 'assets/images/gallery/value3.jpg',
    title: 'Competitive Spirit',
    desc: 'We play to win, push each other forward, and enjoy the journey together.',
    catagory: 'steam',
  },
  {
    id: 3,
    image: 'assets/images/gallery/value2.jpg',
    title: 'Authentic',
    desc: 'We stay true to who we are, move with confidence, and never compromise our identity.',
    catagory: 'origin',
  }
];

const OurValues = () => {
  const [items] = useState(OurValuesData);

  return (
    <div className="values-section padding-top padding-bottom">
      <div className="container">
        <div className="section-header text-center">

          {/* TITLE */}
          <h2 className="text-anim-typing js-animate">
            {title}
          </h2>

          {/* SUBTITLE */}
          <p className="section-subtitle text-anim-fade-soft js-animate delay-md">
            {subtitle}
          </p>

        </div>

        <div className="row g-4 values-gallery">
          {items.map((elem) => {
            const { id, image, title, desc } = elem;
            return (
              <div className="col-lg-4 col-sm-6 col-12 values-item-col" key={id}>
                <div className="values-item">
                  <div className="values-thumb">
                    <img src={image} alt={title} />
                  </div>

                  <div className="values-content">
                    <h3 className="title text-anim-fade-down js-animate delay-md">
                      {title}
                    </h3>
                    <p className="value-desc text-anim-fade-down js-animate delay-md">
                      {desc}
                    </p>
                  </div>

                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OurValues;
